/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Health_Nav_Landing_Feature_1Inputs */

const en_service_health_nav_landing_feature_1 = /** @type {(inputs: Service_Health_Nav_Landing_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Healthcare navigation`)
};

const fr_service_health_nav_landing_feature_1 = /** @type {(inputs: Service_Health_Nav_Landing_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation en santé`)
};

/**
* | output |
* | --- |
* | "Healthcare navigation" |
*
* @param {Service_Health_Nav_Landing_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_health_nav_landing_feature_1 = /** @type {((inputs?: Service_Health_Nav_Landing_Feature_1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Health_Nav_Landing_Feature_1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_health_nav_landing_feature_1(inputs)
	return fr_service_health_nav_landing_feature_1(inputs)
});